import { FEATURES, hasFeatureFlag } from '@cinch/oxd-utils/feature-flags/src'

export function cleanPageName(str: string): string {
  return str.replace(/[/-]/g, (substring, ...args) => {
    const [position, original] = args

    if (position === 0 || position === original.length - 1) {
      return ''
    }

    if (substring === '/') {
      return ':'
    }

    if (substring === '-') {
      return '_'
    }

    return substring
  })
}

export const rewritePageName = (name: string) => {
  if (name === '') {
    return 'homepage'
  }

  if (name.split(':')[0] === 'vehicle') {
    return 'vehicle_details'
  }

  if (name.split(':')[0] === 'dealers') {
    if (name.split(':')[1] === 'vehicle') {
      return 'vehicle_details'
    }
    if (name.split(':')[1] === 'find_vehicle') {
      return 'find_vehicle'
    }
  }

  if (name.split(':')[0] === 'direct' && name.split(':')[1] === 'vehicle') {
    return 'vehicle_details'
  }

  return name
}

interface PageViewParams {
  location: Location
  prevLocation: Location | undefined
}

/**
 * This method should update the data layer with location information for the pageInfo object
 */
export function updatePageInfo({ location, prevLocation }: PageViewParams): void {
  const oxfordRoutes = ['/dealers/find-vehicle', '/vehicle']
  const cambridgeRoutes = ['/find-vehicle', '/direct/vehicle']

  if (typeof window !== 'undefined') {
    const dl = window.adobeData

    if (dl && dl.page && dl.page.pageInfo) {
      dl.page.pageInfo.pageURL = location.href
      dl.page.pageInfo.pageName = rewritePageName(cleanPageName(location.pathname))

      if (prevLocation) {
        dl.page.pageInfo.previousPageName = rewritePageName(cleanPageName(prevLocation.pathname || ''))
      }

      dl.page.pageInfo.journeyName = ''
      if (hasFeatureFlag(FEATURES.CAMBRIDGE)) {
        if (cambridgeRoutes.filter((x) => location.pathname.startsWith(x)).length > 0) {
          dl.page.pageInfo.journeyName = 'cambridge'
        } else if (oxfordRoutes.filter((x) => location.pathname.startsWith(x)).length > 0) {
          dl.page.pageInfo.journeyName = 'oxford'
        }
      }
    }
  }
}

export default updatePageInfo
